module.exports = __webpack_public_path__ + "static/media/eps.f1314dd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/eps.png
// module id = 74
// module chunks = 0